export default "__VITE_ASSET__BWGcwoOm__"